import { request } from "@umijs/max";

/**
 * POST 请求
 * @param url 请求地址
 * @param body 请求体
 * @param options 额外选项
 * @returns 请求结果
 */
export function postRequest<T>(url: string, body?: any, options?: any) {
  return request<T>(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
    data: body,
  })
}

/**
 * GET 请求
 * @param url 请求地址
 * @param params 查询参数
 * @returns 请求结果
 */
export function getRequest<T>(url: string, params?: any) {
  return request<T>(url, {
    method: "GET",
    params,
  });
}

/**
 * PUT 请求
 * @param url 请求地址
 * @param body 请求体
 * @param options 额外选项
 * @returns 请求结果
 */
export function putRequest<T>(url: string, body?: any, options?: any) {
  return request<T>(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
    data: body,
  })
}

/**
 * DELETE 请求
 * @param url 请求地址
 * @returns 请求结果
 */
export function deleteRequest<T>(url: string) {
  return request<T>(url, {
    method: "DELETE",
  });
}

/**
 * DELETE 请求（带请求体）
 */
export function deleteRequestWithBody<T>(url: string, body?: any, options?: any) {
  return request<T>(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
    data: body,
  });
}

/**
 * PATCH 请求
 * @param url 请求地址
 * @param body 请求体
 * @returns 请求结果
 */
export function patchRequest<T>(url: string, body?: any) {
  return request<T>(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  });
}

